// extracted by mini-css-extract-plugin
export default {"wrapper":"link_wrapper__afgD+","linkStyles":"link_linkStyles__R2OLB"};